import React from 'react';

function UnauthorizedPage() {
  return <h2>403 - Je hebt geen toegang tot deze pagina</h2>;
}

export default UnauthorizedPage;
